// extracted by mini-css-extract-plugin
module.exports = {"container":"_2jpoziQaKl6R92j4RGmeCY"};